/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export const KONFIGURIERBARE_LISTENANSICHT_TYP = {
    SEMINARE: "SEMINARE",
    TEILNAHMEN: "TEILNAHMEN",
    ZAHLUNGEN: "ZAHLUNGEN",
    ADRESSEN: "ADRESSEN",
    DOZIERENDE: "DOZIERENDE"
} as const;

type KonfigurierbareListenansichtTyp = keyof typeof KONFIGURIERBARE_LISTENANSICHT_TYP;

export default KonfigurierbareListenansichtTyp;